"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5642],{

/***/ 85642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx


var Header = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6590), __webpack_require__.e(8977)]).then(__webpack_require__.bind(__webpack_require__, 68977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68977)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6590), __webpack_require__.e(6206)]).then(__webpack_require__.bind(__webpack_require__, 6206));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6206)
            ];
        }
    }
});
function Layout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./src/components/Layout/index.tsx




/***/ })

}]);